module.exports = __webpack_public_path__ + "img/banner_top.dad1fc08.png";